export default __webpack_public_path__ + "static/media/bubbles_responsive.edbcf059.png";